<template>
  <m-base>
    <!--<m-section-banner/>-->
    <!--<m-section-prospects/>-->
    <!--<m-section-service />-->
    <!--<m-section-analyze />-->
    <m-v5/>
    
  </m-base>
</template>

<script>
  import MBase from '@/components/layouts/MBase'
  import MSectionBanner from '@/components/landings/MSectionBanner'
  import MSectionProspects from '@/components/landings/MSectionProspects'
  import MSectionService from '@/components/landings/MSectionService'
  import MSectionAnalyze from '@/components/landings/MSectionAnalyze'
  import MV5 from '@/components/landings/MV5'

  export default {
    components: {
      MV5,
      MBase,
      MSectionBanner,
      MSectionProspects,
      MSectionService,
      MSectionAnalyze
    },
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        showGoTop: false
      }
    },
    created () {
      this.toggleGoTop()
    },
    methods: {
      toggleGoTop () {
        var that = this
        window.onscroll = function () {
          let top = document.documentElement.scrollTop || document.body.scrollTop
          if (top > 300) {
            that.showGoTop = true
          } else {
            that.showGoTop = false
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .go-top {
    position: fixed;
    right: 64px;
    top: 60%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    cursor: pointer;
  }

  @media(max-width: 768px) {
    .go-top {
      right: 16px;
      bottom: 32px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Landing3.vue